export default "__VITE_ASSET__1f199534__"